import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SurveyAnswer {
  categoryId: number;
  questionId: number;
  optionId: number | null;
  answerText: string | null;
}

interface SurveyState {
  answers: SurveyAnswer[];
  skippedQuestions: number[];
  notEligibleQuestions: number[];
  finalSubmitEnabled: boolean;
}

const initialState: SurveyState = {
  answers: [],
  skippedQuestions: [],
  notEligibleQuestions: [],
  finalSubmitEnabled: false,
};

const surveySlice = createSlice({
  name: "survey",
  initialState,
  reducers: {
    setAnswer: (state, action: PayloadAction<SurveyAnswer>) => {
      const { categoryId, questionId } = action.payload;
      const existingIndex = state.answers.findIndex(
        (answer) => answer.categoryId === categoryId && answer.questionId === questionId
      );

      if (existingIndex !== -1) {
        state.answers[existingIndex] = action.payload;
      } else {
        state.answers.push(action.payload);
      }
    },
    setSkippedQuestions: (state, action: PayloadAction<number[]>) => {
      state.skippedQuestions = action.payload;
    },
    clearAnswers: (state) => {
      state.answers = [];
      state.skippedQuestions = [];
    },
    removeAnswersForQuestions: (state, action: PayloadAction<number[]>) => {
      state.answers = state.answers.filter(
        (answer) => !action.payload.includes(answer.questionId)
      );
    },
    setNotEligibleQuestions: (state, action: PayloadAction<number[]>) => {
      state.notEligibleQuestions = action.payload;
    },
    addNotEligibleQuestion: (state, action: PayloadAction<number>) => {
      if (!state.notEligibleQuestions.includes(action.payload)) {
        state.notEligibleQuestions.push(action.payload);
      }
    },
    removeNotEligibleQuestion: (state, action: PayloadAction<number>) => {
      state.notEligibleQuestions = state.notEligibleQuestions.filter(
        id => id !== action.payload
      );
    },
    setFinalSubmitEnabled: (state, action: PayloadAction<boolean>) => {
      state.finalSubmitEnabled = action.payload;
    },
  },
});

export const {
  setAnswer,
  setSkippedQuestions,
  clearAnswers,
  removeAnswersForQuestions,
  setNotEligibleQuestions,
  addNotEligibleQuestion,
  removeNotEligibleQuestion,
  setFinalSubmitEnabled,
} = surveySlice.actions;
export default surveySlice.reducer; 